import type { ReactNode, JSX} from "react";
import { Row } from "./Row";
import { Text } from "./Text";

export interface SectionHeaderProps {
  /** Section title text */
  readonly title: string;
  /** Optional action element (e.g. add button) */
  readonly action?: ReactNode;
  /** Extra className */
  readonly className?: string;
}

/**
 * A section header with title and optional trailing action.
 * Used for "Notes", "Tags", "Stats", "Team" sections in sidebars.
 */
export function SectionHeader({ title, action, className }: SectionHeaderProps): JSX.Element {
  return (
    <Row align="center" justify="between" className={className}>
      <Text variant="body" weight="semibold">{title}</Text>
      {action}
    </Row>
  );
}
